import { set } from 'features/app/appSlice';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';
import { CreateTaskModal } from 'pages/documents_v2/views/edit_area/modals/CreateTaskModal';
import { EditLabelBlockModal } from 'pages/documents_v2/views/edit_area/modals/EditLabelBlockModal';
import { EditPackageReimbursementModal } from 'pages/documents_v2/views/edit_area/modals/EditPackageReimbursementModal';
import { ShareModal } from 'pages/documents_v2/views/edit_area/modals/ShareModal';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import HelperFunctions from '../../../global/HelperFunctions';
import { useGetDocument } from '../../hooks/useGetDocument';
import { BlockImprovementModal } from '../../modals/BlockImprovementModal';
import { EditTagModal } from '../../modals/EditTagModal';
import { LinkedBlockModal } from '../../modals/LinkedBlockModal';
import { PreviousBlockVersionsModal } from '../../modals/PreviousBlockVersionsModal';
import { ShowLinkedBlocksModal } from '../../modals/ShowLinkedBlocksModal';

export function BlockEditModals() {
    const dispatch = useDispatch();
    const { blockEditModal } = useSelector((state) => state.app);
    const document = useGetDocument();
    const { updateBlock } = useContext(EditAreaContext);

    if (blockEditModal === undefined) {
        return null;
    }

    const { eventKey, block, blockIndex } = blockEditModal;

    if (eventKey === 'blockImprovementModal') {
        return (
            <BlockImprovementModal
                block={block}
                document={document}
                handleClose={() => closeModal()}
                handleBlockChange={(newValue) => {
                    updateBlock(newValue, blockIndex);
                }}
            />
        );
    }

    if (eventKey === 'labelBlockModal') {
        return <EditLabelBlockModal block={block} handleClose={() => closeModal()} index={blockIndex} />;
    }

    if (eventKey === 'linkedBlockModal') {
        return (
            <LinkedBlockModal
                block={block}
                handleClose={() => closeModal()}
                handleBlockChange={(newValue) => {
                    updateBlock(newValue, blockIndex);
                    closeModal();
                }}
            />
        );
    }

    if (eventKey === 'previousBlockVersions') {
        return <PreviousBlockVersionsModal block={block} handleClose={() => closeModal()} />;
    }

    if (eventKey === 'showLinkedBlockModal') {
        return <ShowLinkedBlocksModal block={block} handleClose={() => closeModal()} />;
    }

    if (eventKey === 'reimbursementBlockModal') {
        const blockData = HelperFunctions.tryParseJSON(block.latestContent);

        return (
            <EditPackageReimbursementModal
                showModal={true}
                handleClose={() => closeModal()}
                handleFormSubmit={(code) => {
                    updateBlock(
                        JSON.stringify({
                            data: [],
                            code,
                        }),
                        blockIndex,
                    );
                    closeModal();
                }}
                categoryId={document.reimbursementCategoryId}
                formData={{
                    id: block.id,
                    code: blockData?.code ?? '',
                }}
            />
        );
    }

    if (eventKey === 'editTagModal') {
        return (
            <EditTagModal
                tag={blockEditModal.tag}
                handleClose={() => closeModal()}
                filterByVariants={block.documentVariants}
            />
        );
    }

    if (eventKey === 'shareModal') {
        return <ShareModal block={block} handleClose={() => closeModal()} />;
    }

    if (eventKey === 'createTaskModal') {
        return <CreateTaskModal block={block} handleClose={() => closeModal()} />;
    }

    return null;

    function closeModal() {
        dispatch(
            set({
                key: 'blockEditModal',
                value: undefined,
            }),
        );
    }
}
